/**
 * @author Fernando Ruano
 * @file titles.js
 * @description Page titles
 */

import moment from 'moment';
import { onGetCapitalDate } from '@nephro/commons/helpers/string-helper';

export const pageTitlesStaff = [
  {
    path: '/main/dashboard',
    title: `Hoy es ${onGetCapitalDate(moment().locale('es'))}`,
    subTitle: `Última actualización`,
    hasBack: false
  },
  {
    path: '/main/rol-management',
    title: 'dashboard.roles',
    subTitle: 'pageHeader.manageRoles',
    hasBack: false
  },
  {
    path: '/main/rol-management/create',
    title: 'dashboard.roles',
    subTitle: 'roleMg.create',
    hasBack: true
  },
  {
    path: '/main/rol-management/view/:id',
    title: 'pageHeader.managePerms',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/rol-management/edit/:id',
    title: 'dashboard.roles',
    subTitle: 'roleMg.edit',
    hasBack: true
  },
  {
    path: '/main/systems-parameters',
    title: 'dashboard.paramSystem',
    subTitle: 'pageHeader.manageParams',
    hasBack: false
  },
  {
    path: '/main/systems-parameters/create',
    title: 'dashboard.paramSystem',
    subTitle: 'paramMg.create',
    hasBack: true
  },
  {
    path: '/main/systems-parameters/view/:id',
    title: 'dashboard.paramSystem',
    subTitle: 'paramMg.view',
    hasBack: true
  },
  {
    path: '/main/systems-parameters/edit/:id',
    title: 'dashboard.paramSystem',
    subTitle: 'paramMg.edit',
    hasBack: true
  },
  {
    path: '/main/users-management',
    title: 'dashboard.users',
    subTitle: 'pageHeader.manageUsers',
    hasBack: false
  },
  {
    path: '/main/users-management/create',
    title: 'dashboard.users',
    subTitle: 'pageHeader.createUser',
    hasBack: true
  },
  {
    path: '/main/users-management/view/:id',
    title: 'dashboard.users',
    subTitle: 'pageHeader.viewItem',
    hasBack: true
  },
  {
    path: '/main/users-management/edit/:id',
    title: 'dashboard.users',
    subTitle: 'curMg.edit',
    hasBack: true
  },
  {
    path: '/main/patients',
    title: 'dashboard.patients',
    subTitle: 'pageHeader.managePatients',
    hasBack: false
  },
  {
    path: '/main/patient_records',
    title: 'dashboard.registerPatients',
    subTitle: '',
    hasBack: false
  },
  {
    path: '/main/patients/create',
    title: 'dashboard.patients',
    subTitle: 'patientMg.create',
    hasBack: true
  },
  {
    path: '/main/patients/view/:id',
    title: 'dashboard.patients',
    subTitle: 'pageHeader.viewItem',
    hasBack: true
  },
  {
    path: '/main/patients/edit/:id',
    title: 'dashboard.patients',
    subTitle: 'pageHeader.editItem',
    hasBack: true
  },
  {
    path: '/main/patients/massive-processing',
    title: 'dashboard.patients',
    subTitle: 'patientMg.massive_processing',
    hasBack: true
  },
  {
    path: '/main/patients/massive-processing/:id',
    title: 'patientMg.massive_processing',
    hasBack: false
  },
  {
    path: '/main/profiles',
    title: 'dashboard.profiles',
    subTitle: 'pageHeader.manageProfiles',
    hasBack: false
  },
  {
    path: '/main/profiles/create',
    title: 'dashboard.profiles',
    subTitle: 'profileMg.create',
    hasBack: true
  },
  {
    path: '/main/profiles/view/:id',
    title: 'dashboard.profiles',
    subTitle: 'profileMg.view',
    hasBack: true
  },
  {
    path: '/main/profiles/edit/:id',
    title: 'dashboard.profiles',
    subTitle: 'profileMg.edit',
    hasBack: true
  },
  {
    path: '/main/medical-parameters',
    title: 'dashboard.paramMedical',
    subTitle: 'pageHeader.manageParams',
    hasBack: false
  },
  {
    path: '/main/medical-parameters/create',
    title: 'dashboard.paramMedical',
    subTitle: 'paramMg.create',
    hasBack: true
  },
  {
    path: '/main/medical-parameters/view/:id',
    title: 'dashboard.paramMedical',
    subTitle: 'paramMg.view',
    hasBack: true
  },
  {
    path: '/main/medical-parameters/edit/:id',
    title: 'dashboard.paramMedical',
    subTitle: 'paramMg.edit',
    hasBack: true
  },
  {
    path: '/main/educational-material/',
    title: 'dashboard.Categories',
    subTitle: 'dashboard.educationalMaterial',
    hasBack: true
  },
  {
    path: '/main/educational-material/element',
    title: 'dashboard.Element',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/educational-material/element/:id',
    title: 'dashboard.Element',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/educational-material/category/:id/load',
    title: 'dashboard.uploadMaterial',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/educational-material/category/:id/edit',
    title: 'dashboard.editMaterial',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/educational-material/category/:id',
    title: 'dashboard.Category',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/scheduled-appointments',
    title: 'dashboard.scheduledAppoint',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/appointments',
    title: 'dashboard.myAppointments',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/appointments/calendar',
    title: 'dashboard.myAppointments',
    subTitle: 'dashboard.calendar',
    hasBack: true
  },
  {
    path: '/main/appointments/schedule',
    title: 'dashboard.schedule',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/appointments/reschedule-appointment',
    title: 'dashboard.reschedule',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/dashboard-detail',
    title: '',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/dashboard-detail/recommended-by-scheduling',
    title: 'dashboardStaff.recommendedByScheduling',
    subTitle: '',
    hasBack: true,
    backPosition: '#F6'
  },
  {
    path: '/main/dashboard-detail/missed-appointments-by-stage',
    title: 'pageHeader.missedAppointments',
    subTitle: '',
    hasBack: true,
    backPosition: '#F7'
  },
  {
    path: '/main/dashboard-detail/access',
    title: 'dashboardStaff.access',
    subTitle: '',
    hasBack: true,
    backPosition: '#F22'
  },
  {
    path: `/main/dashboard-detail/antibody-anti-hbs`,
    title: 'dashboardStaff.antiBodyAntiHBs',
    subTitle: '',
    hasBack: true,
    backPosition: '#F10'
  },
  {
    path: `/main/dashboard-detail/ambulatory-monitoring-ib`,
    title: '',
    subTitle: 'dashboardStaff.ambulatoryMonitoring',
    hasBack: true,
    backPosition: '#F43'
  },
  {
    path: `/main/dashboard-detail/ambulatory-monitoring-ig`,
    title: '',
    subTitle: 'dashboardStaff.ambulatoryMonitoring',
    hasBack: true,
    backPosition: '#F43'
  },
  {
    path: `/main/dashboard-detail/proteinuria`,
    title: 'Proteinuria (24h)',
    subTitle: '',
    hasBack: true,
    backPosition: '#F15'
  },
  {
    path: `/main/dashboard-detail/albumina-lab`,
    title: 'Albumina',
    subTitle: '',
    hasBack: true,
    backPosition: '#dashboard-lab'
  },
  {
    path: `/main/dashboard-detail/albuminuria`,
    title: 'Albuminuria',
    subTitle: '',
    hasBack: true,
    backPosition: '#F13'
  },
  {
    path: `/main/dashboard-detail/albuminuria-progress`,
    title: 'dashboardStaff.albuminuriaProgress',
    subTitle: '',
    hasBack: true,
    backPosition: '#F14'
  },
  {
    path: `/main/dashboard-detail/tfg-deterioration`,
    title: 'dashboardStaff.TFGDeterioration',
    subTitle: '',
    hasBack: true,
    backPosition: '#F16'
  },
  {
    path: `/main/dashboard-detail/nutritional-indicator`,
    title: 'dashboardStaff.nutritionalIndicator',
    subTitle: '',
    hasBack: true,
    backPosition: '#F27'
  },
  {
    path: `/main/dashboard-detail/hemoglobin`,
    title: 'Hemoglobina',
    subTitle: '',
    hasBack: true,
    backPosition: '#dashboard-lab'
  },
  {
    path: `/main/dashboard-detail/potassium`,
    title: 'Potasio',
    subTitle: '',
    hasBack: true,
    backPosition: '#dashboard-lab'
  },
  {
    path: `/main/dashboard-detail/metabolic-control-diabetes`,
    title: 'dashboardStaff.metabolicDiabetesTitle',
    subTitle: '',
    hasBack: true,
    backPosition: '#F21'
  },
  {
    path: `/main/dashboard-detail/phosphorus`,
    title: 'Fósforo',
    subTitle: '',
    hasBack: true,
    backPosition: '#dashboard-lab'
  },
  {
    path: `/main/dashboard-detail/pth`,
    title: 'PTH',
    subTitle: '',
    hasBack: true,
    backPosition: '#dashboard-lab'
  },
  {
    path: `/main/dashboard-detail/seroStatusHepatitisB`,
    title: 'dashboardStaff.seroStatusHepatitisB',
    subTitle: '',
    hasBack: true,
    backPosition: '#F8'
  },
  {
    path: `/main/dashboard-detail/risk`,
    title: 'dashboardStaff.risk',
    subTitle: '',
    hasBack: true,
    backPosition: '#F17'
  },
  {
    path: `/main/dashboard-detail/bloodPressure`,
    title: 'dashboardStaff.bloodPressureControl',
    subTitle: '',
    hasBack: true,
    backPosition: '#F20'
  },
  {
    path: `/main/dashboard-detail/vaccine-scheduling`,
    title: 'dashboardStaff.vaccinationScheduling',
    subTitle: '',
    hasBack: true,
    backPosition: '#F9'
  },
  {
    path: `/main/dashboard-detail/post-vaccine-anti-hbs`,
    title: 'dashboardStaff.postVaccineAntiHbs',
    subTitle: '',
    hasBack: true,
    backPosition: '#F11'
  },
  {
    path: `/main/dashboard-detail/risk-register`,
    title: 'dashboardStaff.riskRegister',
    subTitle: '',
    hasBack: true,
    backPosition: '#F19'
  },
  {
    path: `/main/dashboard-detail/loss-hepatitis-immunity`,
    title: 'dashboardStaff.lossHepatitisImmunity',
    subTitle: '',
    hasBack: true,
    backPosition: '#F12'
  },
  {
    path: `/main/dashboard-detail/correlation-risk-rate-progression`,
    title: 'dashboardStaff.correlationRiskRateProgression',
    subTitle: '',
    hasBack: true,
    backPosition: '#F18'
  },
  {
    path: `/main/dashboard-detail/treatment-options`,
    title: 'dashboardStaff.treatmentOptions',
    subTitle: '',
    hasBack: true,
    backPosition: '#F23'
  },
  {
    path: `/main/dashboard-detail/psychosocial-risk-psycology`,
    title: 'dashboardStaff.psychosocialRiskPsychology',
    subTitle: '',
    hasBack: true,
    backPosition: '#F34'
  },
  {
    path: `/main/dashboard-detail/scheduling-alert-list`,
    title: 'dashboardStaff.schedulingAlert',
    subTitle: '',
    hasBack: true,
    backPosition: '#F25'
  },
  {
    path: `/main/dashboard-detail/protein-energetic-wear-list`,
    title: 'dashboardStaff.proteinEnergeticWear',
    subTitle: '',
    hasBack: true,
    backPosition: '#F26'
  },
  {
    path: `/main/dashboard-detail/general-social-t-social-risk-list`,
    title: 'dashboardStaff.generalSocialTSocialRisk',
    subTitle: '',
    hasBack: true,
    backPosition: '#F38'
  },
  {
    path: `/main/dashboard-detail/assesment-in-psychology`,
    title: 'dashboardStaff.assesmentPsychology',
    subTitle: '',
    hasBack: true,
    backPosition: '#F37'
  },
  {
    path: `/main/dashboard-detail/nursing-education`,
    title: 'dashboardStaff.nursingEducation',
    subTitle: '',
    hasBack: true,
    backPosition: '#F33'
  },
  {
    path: `/main/dashboard-detail/dissent-psychology-assessment`,
    title: 'dashboardStaff.PatientsDissentTitle',
    subTitle: '',
    hasBack: true,
    backPosition: '#F36'
  },
  {
    path: `/main/dashboard-detail/patient-events`,
    title: 'dashboardStaff.patientEvents',
    subTitle: '',
    hasBack: true,
    backPosition: '#F41'
  },
  {
    path: `/main/dashboard-detail/periodicity-attention`,
    title: 'dashboardStaff.periodicityAttention',
    subTitle: '',
    hasBack: true,
    backPosition: '#F40'
  },
  {
    path: `/main/dashboard-detail/construction-access-assessment-list`,
    title: 'dashboardStaff.constructionAccessAssessment',
    subTitle: '',
    hasBack: true,
    backPosition: '#F24'
  },
  {
    path: `/main/dashboard-detail/psychosocial-risk-list`,
    title: 'dashboardStaff.psychosocialRisk',
    subTitle: '',
    hasBack: true,
    backPosition: '#F35'
  },
  {
    path: `/main/dashboard-detail/general-social-risk-register`,
    title: 'dashboardStaff.psychosocialGeneralRisk',
    subTitle: '',
    hasBack: true,
    backPosition: '#F42'
  },
  {
    path: `/main/dashboard-detail/follow-up-absenteeism-adherence`,
    title: 'dashboardStaff.FollowUp',
    subTitle: '',
    hasBack: true,
    backPosition: '#F39'
  },
  {
    path: '/main/stages',
    title: 'dashboard.myStage',
    subTitle: 'dashboard.myStage',
    hasBack: true
  },
  {
    path: '/main/patient-blood-presure',
    title: `dashboard.records`,
    subTitle: ``,
    hasBack: true
  },
  {
    path: '/main/about',
    title: 'dashboard.aboutApp',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/terms-and-conditions',
    title: 'dashboard.termsAndConditions',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/privacy',
    title: 'Política de privacidad',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/videocalls-frame/',
    title: 'dashboard.videoCalls',
    subTitle: '',
    hasBack: true
  }
];

export const pageTitlesPatient = (string) => [
  {
    path: '/main/dashboard',
    title: string,
    subTitle: 'pageHeader.patient',
    hasBack: false
  },
  {
    path: '/main/my-profile',
    title: 'dashboard.myProfile',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/my-profile/changePassword',
    title: 'registration.changePass',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/educational-material/',
    title: 'dashboard.Categories',
    subTitle: 'dashboard.ITakeCare',
    hasBack: true
  },
  {
    path: '/main/educational-material/element/',
    title: 'dashboard.Element',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/educational-material/element/:id',
    title: 'dashboard.Element',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/educational-material/category/:id',
    title: 'dashboard.Category',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/appointments/',
    title: 'dashboard.myAppointments',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/appointments/calendar',
    title: 'dashboard.myAppointments',
    subTitle: 'dashboard.calendar',
    hasBack: true
  },
  {
    path: '/main/appointments/schedule',
    title: 'dashboard.schedule',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/appointments/reschedule-appointment',
    title: 'dashboard.reschedule',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/patient-blood-presure',
    title: 'dashboard.myRecords',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/blood-presure',
    title: 'dashboard.bloodPressure',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/videocalls-frame/',
    title: 'dashboard.videoCalls',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/nephro-plus-chat/',
    title: 'dashboard.nephroPlusChat',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/patient-stages',
    title: 'dashboard.stage',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/patient-adherence',
    title: 'dashboardPatient.adherenceTitle',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/patient-nutritional',
    title: 'dashboardPatient.nutritionalTitle',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/patient-blood-glucose',
    title: 'dashboardPatient.bloodGlucoseTitle',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/stages',
    title: 'dashboard.myStage',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/kidney-progression',
    title: 'dashboardPatient.kidneyProgressTitle',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/exams',
    title: 'dashboard.myLabs',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/patient-my-recomendations',
    title: 'dashboard.myRecommendations',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/patient-my-recomendations/details',
    title: 'dashboard.myRecommendations',
    subTitle: 'commons.myRecDetails',
    hasBack: true
  },
  {
    path: '/main/events',
    title: 'dashboardPatient.myEvents',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/events/eventTypes',
    title: 'dashboardPatient.myEvents',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/events/form',
    title: 'dashboardPatient.myEvents',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/events/edit',
    title: 'dashboardPatient.myEvents',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/about',
    title: 'dashboard.aboutApp',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/terms-and-conditions',
    title: 'dashboard.termsAndConditions',
    subTitle: '',
    hasBack: true
  },
  {
    path: '/main/privacy',
    title: 'Política de privacidad',
    subTitle: '',
    hasBack: true
  }
];
